import React from "react";
import { useSelector } from "react-redux";

interface ButtonTrayProps {
    selectedButton: any;
    onButtonChange: any;
}

function ButtonTray({ selectedButton, onButtonChange }: ButtonTrayProps): JSX.Element {
    const userEmail = useSelector((state: any) => state.auth?.user?.email);

    const isSam = userEmail?.trim()?.toLowerCase() === "sam@kimaru.ai";

    const manufacturingButtons = [
        {
            id: "component",
            label: "Component",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clipPath="url(#clip0_658_16573)">
                        <path d="M6.66673 14.5994V9.33275M6.66673 9.33275L1.40007 6.06608M6.66673 9.33275L14.6 4.73275M9.33334 13.1993V7.79932M12 11.666V6.26595M14.6667 5.13262C14.6667 4.73262 14.4 4.33262 14.1333 4.13262L9.93334 1.53262C9.76061 1.43443 9.56535 1.38281 9.36667 1.38281C9.16799 1.38281 8.97272 1.43443 8.8 1.53262L1.93334 5.53262C1.6 5.66595 1.33334 6.06595 1.33334 6.46595V10.8659C1.33334 11.1993 1.6 11.6659 1.86667 11.8659L6.06667 14.466C6.23939 14.5641 6.43466 14.6158 6.63334 14.6158C6.83201 14.6158 7.02728 14.5641 7.2 14.466L14.0667 10.466C14.4 10.266 14.6667 9.79928 14.6667 9.46595V5.13262Z" stroke="#111827" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_658_16573">
                            <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
        {
            id: "supplier",
            label: "Supplier",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clipPath="url(#clip0_658_16577)">
                        <path d="M11.3333 12.0007H12M8 12.0007H8.66666M4.66666 12.0007H5.33333M1.33333 13.334C1.33333 13.6876 1.4738 14.0267 1.72385 14.2768C1.9739 14.5268 2.31304 14.6673 2.66666 14.6673H13.3333C13.687 14.6673 14.0261 14.5268 14.2761 14.2768C14.5262 14.0267 14.6667 13.6876 14.6667 13.334V5.33398L10 8.66732V5.33398L5.33333 8.66732V2.66732C5.33333 2.3137 5.19285 1.97456 4.9428 1.72451C4.69276 1.47446 4.35362 1.33398 3.99999 1.33398H2.66666C2.31304 1.33398 1.9739 1.47446 1.72385 1.72451C1.4738 1.97456 1.33333 2.3137 1.33333 2.66732V13.334Z" stroke="#111827" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_658_16577">
                            <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
        {
            id: "location",
            label: "Location",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.3333 6.66732C13.3333 10.6673 7.99999 14.6673 7.99999 14.6673C7.99999 14.6673 2.66666 10.6673 2.66666 6.66732C2.66666 5.25283 3.22856 3.89628 4.22875 2.89608C5.22895 1.89589 6.5855 1.33398 7.99999 1.33398C9.41448 1.33398 10.771 1.89589 11.7712 2.89608C12.7714 3.89628 13.3333 5.25283 13.3333 6.66732Z" stroke="#111827" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7.99999 8.66732C9.10456 8.66732 9.99999 7.77189 9.99999 6.66732C9.99999 5.56275 9.10456 4.66732 7.99999 4.66732C6.89542 4.66732 5.99999 5.56275 5.99999 6.66732C5.99999 7.77189 6.89542 8.66732 7.99999 8.66732Z" stroke="#111827" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ),
        },
    ];

    const defaultButtons = [
        {
            id: "product",
            label: "Product",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                        d="M2 4.66667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H4.66667M11.3333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V4.66667M14 11.3333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H11.3333M4.66667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V11.3333M5.33333 4.66667V11.3333M8 4.66667V11.3333M11.3333 4.66667V11.3333"
                        stroke={selectedButton === "product" ? "#111827" : "#9CA3AF"}
                        strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"
                    />
                </svg>
            ),
        },
        {
            id: "store",
            label: "Store",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                        d="M1.33203 4.66634L4.27203 1.72634C4.39607 1.60156 4.54358 1.50257 4.70605 1.43506C4.86853 1.36755 5.04276 1.33287 5.2187 1.33301H10.7787C10.9546 1.33287 11.1289 1.36755 11.2913 1.43506C11.4538 1.50257 11.6013 1.60156 11.7254 1.72634L14.6654 4.66634M1.33203 4.66634H14.6654M1.33203 4.66634V6.66634C1.33203 7.01996 1.47251 7.3591 1.72256 7.60915C1.9726 7.8592 2.31174 7.99967 2.66536 7.99967M14.6654 4.66634V6.66634C14.6654 7.01996 14.5249 7.3591 14.2748 7.60915C14.0248 7.8592 13.6857 7.99967 13.332 7.99967M2.66536 7.99967V13.333C2.66536 13.6866 2.80584 14.0258 3.05589 14.2758C3.30594 14.5259 3.64508 14.6663 3.9987 14.6663H11.9987C12.3523 14.6663 12.6915 14.5259 12.9415 14.2758C13.1916 14.0258 13.332 13.6866 13.332 13.333V7.99967M9.9987 14.6663V11.9997C9.9987 11.6461 9.85822 11.3069 9.60817 11.0569C9.35813 10.8068 9.01899 10.6663 8.66536 10.6663H7.33203C6.97841 10.6663 6.63927 10.8068 6.38922 11.0569C6.13917 11.3069 5.9987 11.6461 5.9987 11.9997V14.6663"
                        stroke={selectedButton === "store" ? "#111827" : "#9CA3AF"}
                        strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"
                    />
                </svg>
            ),
        },
        {
            id: "container",
            label: "Container",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                        d="M5 2.84701L11 6.28034M2.20003 4.66699L8.00003 8.00033M8.00003 8.00033L13.8 4.66699M8.00003 8.00033L8 14.667M14 5.33359C13.9998 5.09978 13.938 4.87013 13.821 4.6677C13.704 4.46527 13.5358 4.29717 13.3333 4.18026L8.66667 1.51359C8.46397 1.39657 8.23405 1.33496 8 1.33496C7.76595 1.33496 7.53603 1.39657 7.33333 1.51359L2.66667 4.18026C2.46418 4.29717 2.29599 4.46527 2.17897 4.6677C2.06196 4.87013 2.00024 5.09978 2 5.33359V10.6669C2.00024 10.9007 2.06196 11.1304 2.17897 11.3328C2.29599 11.5353 2.46418 11.7034 2.66667 11.8203L7.33333 14.4869C7.53603 14.604 7.76595 14.6656 8 14.6656C8.23405 14.6656 8.46397 14.604 8.66667 14.4869L13.3333 11.8203C13.5358 11.7034 13.704 11.5353 13.821 11.3328C13.938 11.1304 13.9998 10.9007 14 10.6669V5.33359Z"
                        stroke={selectedButton === "container" ? "#111827" : "#9CA3AF"}
                        strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"
                    />
                </svg>
            ),
        },
    ];

    const buttons = isSam ? manufacturingButtons : defaultButtons;

    return (
        <div className="flex gap-1">
            {buttons.map((button: any) => (
                <button
                    key={button.id}
                    onClick={() => !button.disabled && onButtonChange(button.id)}
                    disabled={button.disabled}
                    className={`
                        flex items-center justify-center gap-2 h-9 px-2.5 py-2.5
                        rounded-md transition-colors
                        ${selectedButton === button.id
                            ? "bg-zinc-100"
                            : button.disabled
                                ? "opacity-50 cursor-not-allowed bg-transparent"
                                : "bg-transparent hover:bg-gray-50"}
                    `}
                    style={{
                        height: "36px",
                        padding: "10px",
                        gap: "8px",
                    }}
                >
                    {button.icon}
                    <span
                        className={`text-sm font-medium ${button.disabled ? "text-gray-400" : "text-gray-900"}`}
                    >
                        {button.label}
                    </span>
                </button>
            ))}
        </div>
    );
}

export default ButtonTray;
